/** Idempotency keys for user-composed posts (task comments, project updates).
 *
 *  WHY: posting is a non-idempotent Odoo write, and when a send fails the composer
 *  deliberately KEEPS the draft — so the natural recovery is clicking Send again.
 *  If the first attempt actually landed (slow Odoo, lost response) that posted the
 *  same thing twice and re-pinged everyone it mentioned. A key that is scoped to
 *  the DRAFT — held across retries, rotated only once a send succeeds — lets the
 *  server collapse the retry onto the original message.
 *
 *  Same lifecycle as the cg-pos order token, which likewise rotates only on a
 *  successful clear().
 */
export function newPostKey(): string {
  // randomUUID needs a secure context; keep a fallback so a non-https dev origin
  // still gets dedup protection.
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return `k${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
